'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareData = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _src = require('../../rules/src');
var _refineDimensions = require('./refineDimensions');
var _enhanceObservations = require('./enhanceObservations');
var _parseAttributes = require('./parseAttributes');
var _getCombinationDefinitions = require('./getCombinationDefinitions');
var _parseCombinations = require('./parseCombinations');
var _refineAttributes = require('./refineAttributes');
var _duplicateObservations = require('./duplicateObservations');
var _getMetadataCoordinates = require('./getMetadataCoordinates');
var _getAttributesSeries = require('./getAttributesSeries');
var _getManyValuesDimensions = require('./getManyValuesDimensions');
var _getOneValueDimensions = require('./getOneValueDimensions');
var _hierarchiseDimensionWithNativeHierarchy = require('./hierarchiseDimensionWithNativeHierarchy2');
var _hierarchiseDimensionWithAdvancedHierarchy = require('./hierarchiseDimensionWithAdvancedHierarchy2');
var _getDataflowAttributes = require('./getDataflowAttributes');
var _getHeaderTitle = require('./getHeaderTitle');
var _getHeaderSubtitle = require('./getHeaderSubtitle');
var _getHeaderCombinations = require('./getHeaderCombinations');
var _getHeaderCoordinates = require('./getHeaderCoordinates');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var prepareData = exports.prepareData = function prepareData(sdmxJson, _ref) {
  var customAttributes = _ref.customAttributes,
    locale = _ref.locale,
    hierarchies = _ref.hierarchies,
    dataflow = _ref.dataflow,
    display = _ref.display,
    defaultCombinations = _ref.defaultCombinations,
    dataquery = _ref.dataquery;
  var dimensions = R.pathOr([], ['data', 'structure', 'dimensions', 'observation'], sdmxJson);
  var refinedDimensions = (0, _refineDimensions.refineDimensions)(dimensions, dataquery);
  var attributes = R.pathOr([], ['data', 'structure', 'attributes', 'observation'], sdmxJson);
  var annotations = R.pathOr([], ['data', 'structure', 'annotations'], sdmxJson);
  var observations = (0, _src.getObservations)(sdmxJson);
  var combinations = (0, _getCombinationDefinitions.getCombinationDefinitions)(annotations, locale);
  if (R.isEmpty(combinations) && !R.isEmpty(defaultCombinations)) {
    var concepts = defaultCombinations.concepts,
      names = defaultCombinations.names;
    combinations = (0, _getCombinationDefinitions.parseCombinationDefinition)(locale)(concepts, names);
  }
  var metadataCoordinates = (0, _getMetadataCoordinates.getMetadataCoordinates)(sdmxJson);
  var parsedAttributes = (0, _parseAttributes.parseAttributes)(attributes, refinedDimensions, customAttributes);
  var parsedCombinations = (0, _parseCombinations.parseCombinations)(combinations, parsedAttributes, refinedDimensions);
  var seriesCombinations = R.filter(R.prop('series'), parsedCombinations);
  var refinedAttributes = (0, _refineAttributes.refineAttributes)(parsedAttributes, seriesCombinations);
  var enhancedObservations = (0, _enhanceObservations.enhanceObservations)(refinedDimensions, observations, refinedAttributes, {
    customAttributes: customAttributes
  });
  var attributesSeries = (0, _getAttributesSeries.getAttributesSeries)(enhancedObservations);
  var manyValuesDimensions = (0, _getManyValuesDimensions.getManyValuesDimensions)(refinedDimensions, attributesSeries, customAttributes, seriesCombinations);
  var oneValueDimensions = (0, _getOneValueDimensions.getOneValueDimensions)(refinedDimensions, parsedAttributes);
  var headerCoordinates = (0, _getHeaderCoordinates.getHeaderCoordinates)(oneValueDimensions);
  var hierarchisedDimensions = R.map(function (dim) {
    if (R.isEmpty(R.propOr({}, dim.id, hierarchies))) {
      return (0, _hierarchiseDimensionWithNativeHierarchy.hierarchiseDimensionWithNativeHierarchy)(dim);
    }
    return (0, _hierarchiseDimensionWithAdvancedHierarchy.hierarchiseDimensionWithAdvancedHierarchy)(dim, R.prop(dim.id, hierarchies));
  }, manyValuesDimensions);
  var duplicatedObservations = (0, _duplicateObservations.duplicateObs)(R.values(hierarchisedDimensions), enhancedObservations);
  var dataflowAttributes = (0, _getDataflowAttributes.getDataflowAttributes)(parsedAttributes, parsedCombinations);
  var headerTitle = (0, _getHeaderTitle.getHeaderTitle)(dataflow, dataflowAttributes, display, customAttributes);
  var headerSubtitle = (0, _getHeaderSubtitle.getHeaderSubtitle)(oneValueDimensions, parsedCombinations, customAttributes, display);
  var headerCombinations = (0, _getHeaderCombinations.getHeaderCombinations)(parsedCombinations, oneValueDimensions, refinedAttributes, display);
  return {
    observations: duplicatedObservations,
    dimensions: hierarchisedDimensions,
    combinations: parsedCombinations,
    oneValueDimensions: oneValueDimensions,
    attributesSeries: attributesSeries,
    metadataCoordinates: metadataCoordinates,
    attributes: refinedAttributes,
    header: {
      title: headerTitle,
      subtitle: headerSubtitle,
      combinations: headerCombinations,
      coordinates: headerCoordinates
    }
  };
};